import { defineGameCard } from '../authoring/index.js';
import { GROWTH_KEY } from './plant-helpers.js';
/**
 * Рост — публичный сериализуемый счётчик Растения: unit-scoped persistent
 * Effect с generic counter `growth`. Все изменения идут через
 * `modifyEffectCounter` и публикуются `EffectCounterChanged`, поэтому playback
 * и реплеи объясняют каждое изменение. Само определение поведения не имеет.
 */
export const PlantGrowthCard = defineGameCard({
    id: 'plant_growth',
    gameplay: { type: 'EFFECT', cost: 0 },
    presentation: {
        name: 'Рост',
        description: 'Публичный счётчик Роста на Растении. Тратится на Созревание и другие эффекты; другие карты могут добавлять и снимать Рост.',
        glyph: {
            colors: ['#2E7D4A', '#5ECF6B', '#C9F2A6'],
            rows: [
                '....3....',
                '...232...',
                '..23132..',
                '...131...',
                '..21312..',
                '...121...',
                '....1....',
                '....1....',
                '...111...',
            ],
        },
    },
    role: 'auxiliary',
    ui: {
        mechanics: ['growth'],
        publicVars: { growth: { key: GROWTH_KEY, kind: 'number' } },
        effectStatusProviders: [(_context, effects) => {
                const growth = effects.reduce((total, effect) => {
                    const value = effect.facts.growth;
                    return total + (typeof value === 'number' ? value : 0);
                }, 0);
                return growth > 0
                    ? [{
                            id: 'plant-growth',
                            symbol: `🌱${growth}`,
                            label: `Рост ${growth}`,
                            description: `На карте ${growth} Роста. Рост тратится на Созревание и другие эффекты растений.`,
                            tone: 'positive',
                            compact: true,
                        }]
                    : [];
            }],
    },
});
//# sourceMappingURL=plant_growth.js.map